<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="title">
    <b-form @submit.prevent="save">
      <b-card>
        <b-form-row>
          <lg-form-input-mask :invalidFeedback="'Informe um número válido!'" :mask="'#.#.##.##.##'" description=" "
            :error="$v.form.numero" v-model="form.numero" label="Número: *" cols="12" sm="4" />
        </b-form-row>
        <b-form-row>
          <lg-form-input invalidFeedback="Informe um título válida!" description=" " :error="$v.form.descricao"
            v-model="form.descricao" label="Título: *" cols="12" sm="8" />
        </b-form-row>
        <b-form-row>
          <div class="d-flex align-items-center col-12 form-group">
            <label class="mr-2 text-reset">Status: *</label>
            <b-form-radio-group size="sm" v-model="form.situacao" :options="options" name="situacao-options"
              class="d-flex">
            </b-form-radio-group>
          </div>
        </b-form-row>
        <b-form-row><label class="mr-2 text-reset">Função: *</label>
          <b-form-textarea :state="validateState($v.form.funcao)" id="textarea" v-model="form.funcao" rows="3"
            max-rows="6" />
        </b-form-row>
        <div class="d-flex justify-content-center mt-3">
          <b-button id="salvarContaContabil" type="submit" variant="success" style="height: 30px" pill size="sm">
            <div class="btn-size-alinhamento">
              <b-icon icon="check-circle" />
            </div>
            <b-tooltip target="salvarContaContabil" title="Salvar" triggers="hover"></b-tooltip>

          </b-button>
          <b-button id="cancelarContaContabil" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
            variant="danger">
            <div class="btn-size-alinhamento">
              <b-icon icon="x-circle" />
            </div>
            <b-tooltip target="cancelarContaContabil" title="Cancelar" triggers="hover"></b-tooltip>

          </b-button>
        </div>
      </b-card>
    </b-form>
  </b-modal>
</template>
<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators"

import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormInputMask from "@/core/components/Form/LgFormInputMask.vue"
import { FormResourceMixin } from "@/core/mixins/resource"

export default {
  components: {
    LgFormInput,
    LgFormInputMask,
  },
  mixins: [FormResourceMixin],
  validations: {
    form: {
      numero: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(8)
      },
      descricao: { required },
      funcao: { required },
    },
  },
  props: {
    isModal: Boolean,
    id: Number,
    prefix: {
      type: Array,
      required: true,
    },
    empresaNome: String,
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, this.id == null ? "Cadastro" : "Alteração"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
  },
  data() {
    return {
      showModal: true,
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      form: {
        numero: "",
        descricao: "",
        funcao: "",
        situacao: null,
      },
    }
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/conta-contabil`)
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id)
      this.form = data
    } else {
      this.form.situacao = 1
    }
  },
  methods: {
    validateState(field) {
      if (!field.$dirty) {
        return null
      }
      return field.$invalid ? false : true
    },
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        })
        return
      }

      try {
        await this.$service.save(this.form);
        this.$notify({
          type: "success",
          message: 'Registro salvo com sucesso'
        });
        this.cancelar();

      } catch (e) {
        this.$notify({
          type: "danger",
          message: 'Já existe outra Conta contábil com este número.'
        });
        return;
      }

    },
    cancelar() {
      this.$emit("close")
    },
  },
}
</script>
